/* @ngInject */
const myAxletreesForm = (
  toaster,
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myAxletrees: '=',
      enableValidator: '=',
      defaultWeight: '=',
    },
    template: require('./myAxletreesForm.html'),

    /* @ngInject */
    controller: (
      $scope,
      $$axletree,
      constants
    ) => {
      const resetPosition = () => {
        if (valueHandler.isArray($scope.myAxletrees)) {
          for (let index = 0; index < $scope.myAxletrees.length; index++) {
            $scope.myAxletrees[index].position = constants.arrays.positions[index]
          }
        }
      }
      resetPosition()

      $scope.addAxletree = () => {
        $scope.myAxletrees.push($$axletree.new($scope.defaultWeight))
        resetPosition()
      }

      $scope.removeAxletree = async (_index) => {
        const id = $scope.myAxletrees[_index].id
        if (valueHandler.isId(id)) {
          try {
            const message = await $$axletree.request.delete(id)
            toaster.message(message)
            $scope.myAxletrees.splice(_index, 1)
            resetPosition()
          } catch (error) {
            toaster.error(error)
          }
        } else {
          $scope.myAxletrees.splice(_index, 1)
          resetPosition()
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myAxletreesForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/directives/forms/myAxletreesForm.js